// extracted by mini-css-extract-plugin
module.exports = {"contentArea":"_776c70b","cta":"_bf95c5a","background":"_9090da7","left":"_20ae1ae","center":"_454b768","right":"_dd19a03"};